export default __webpack_public_path__ + "static/media/pencil.b6b8054a.svg";